// Centralized property photography assets for JNN Homes redesign
// Real photos from JNN Homes-managed Northern Virginia Airbnb properties are
// used where available; remaining shots are representative stand-ins for
// spaces not yet photographed.
export const PROPERTY_IMAGES = {
  exteriorDusk:
    "https://vibe.filesafe.space/1778679421893490393/assets/884cf086-8bfc-4a03-a372-246c89c711c7.png",
  livingRoom:
    "https://vibe.filesafe.space/1778679421893490393/attachments/0ac2936b-a5d6-4a75-8432-67bda95d2cb8.jpg",
  kitchen:
    "https://vibe.filesafe.space/1778679421893490393/attachments/a1965024-00ff-4f11-a4ae-510707ffad3a.jpg",
  bedroom:
    "https://vibe.filesafe.space/1778679421893490393/attachments/ef748cc0-fe27-4da2-9796-f018a69f3ef0.jpg",
  goldenHour:
    "https://vibe.filesafe.space/1778679421893490393/assets/d6a3ed7f-07f6-4c59-b18f-6018184e3ac7.png",
  gameRoom:
    "https://vibe.filesafe.space/1778679421893490393/attachments/4d41e6db-b514-4fd9-988c-fcea1cfa25de.jpg",
  openKitchenLiving:
    "https://vibe.filesafe.space/1778679421893490393/attachments/ab9b6b95-eda9-4db2-8931-08a46fb1a87c.jpg",
  livingRoomFireplace:
    "https://vibe.filesafe.space/1778679421893490393/attachments/85fa41db-200e-455e-825c-decbdc2bca4d.jpg",
  livingRoomDining:
    "https://vibe.filesafe.space/1778679421893490393/attachments/02b5f2f7-b831-4954-86dd-872caaf30890.jpg",
  kitchenBright:
    "https://vibe.filesafe.space/1778679421893490393/attachments/747473e6-30ff-44dc-9a55-a975f49b271c.jpg",
  livingRoomBigTv:
    "https://vibe.filesafe.space/1778679421893490393/attachments/16a136ea-826e-4278-80b8-f78a64ff1d1c.jpg",
  sunroomSeating:
    "https://vibe.filesafe.space/1778679421893490393/attachments/caa79e60-ded2-4268-be16-924780de013c.jpg",
  familyRoomBrick:
    "https://vibe.filesafe.space/1778679421893490393/attachments/33e165e0-aabb-45c9-b4cd-e2244678360e.jpg",
  livingRoomBrick2:
    "https://vibe.filesafe.space/1778679421893490393/attachments/27a426c8-5c87-4ae2-b52a-658811d81830.jpg",
  diningRoundMarble:
    "https://vibe.filesafe.space/1778679421893490393/attachments/70d8f0d2-282a-4fb1-aef1-eb05b034a5d4.jpg",
  bedroomCeilingFan:
    "https://vibe.filesafe.space/1778679421893490393/attachments/12ba4143-712a-4ead-af83-27d03bbedf48.jpg",
  livingRoomCurvedSofa:
    "https://vibe.filesafe.space/1778679421893490393/attachments/fdf165fe-780a-434a-91aa-59306eb112c6.jpg",
  loftLivingDining:
    "https://vibe.filesafe.space/1778679421893490393/attachments/08399a1c-4ead-48da-a8e2-b51507f258c6.jpg",
  livingRoomWhiteBuiltIns:
    "https://vibe.filesafe.space/1778679421893490393/attachments/ab3e0dd8-b66b-4f31-a3cf-8494a3d60f5b.jpg",
  cozyLivingRoom:
    "https://vibe.filesafe.space/1778679421893490393/assets/b04d795a-1949-460a-b79b-65eb800e76b3.png",
};
